import { useCallback } from 'react';

import { config as assetUniverseConfig } from '../asset/assetUniverse/AssetUniverseStepConfig.tsx';

import type { NotVerifiedAssetWithId } from '../../../../market/asset/AssetService.tsx';
import PortfolioDefinitionOptimizerContainer from './PortfolioDefinitionOptimizerContainer.tsx';
import {
  type PortfolioDefinitionWithAssetUniverseInputFields,
  type PortfolioDefinitionWithAssetUniverseOutputFields,
  schema,
} from './PortfolioDefinitionWithAssetUniverse.validation.ts';
import { mapStateToDefaultValuesForUniverse } from './PorttfolioDefinitionOptimizerService.ts';
import { useLocation } from 'react-router-dom';
import { usePortfolioDefinitionOptimizerInputSuspenseQuery } from 'generated/graphql.tsx';

const PortfolioDefinitionWithAssetUniverseWizard = () => {
  const location = useLocation();
  const { data } = usePortfolioDefinitionOptimizerInputSuspenseQuery();
  const defaultValues = mapStateToDefaultValuesForUniverse(location.state, data.assets);
  const universeStep = useCallback(
    (props: {
      assets: NotVerifiedAssetWithId[];
      assetIdToClusterToGroup: Record<string, Record<string, string>>;
      goToNextStep: () => void;
    }) =>
      assetUniverseConfig({
        assets: props.assets,
        assetIdToClusterToGroup: props.assetIdToClusterToGroup,
        goToNextStep: props.goToNextStep,
        syncWithOutlook: false,
        hideInitialPortfolio: true,
      }),
    []
  );

  return (
    <PortfolioDefinitionOptimizerContainer<
      PortfolioDefinitionWithAssetUniverseInputFields,
      PortfolioDefinitionWithAssetUniverseOutputFields
    >
      id={location.state?.id}
      universeStep={universeStep}
      schema={schema}
      createOptimizerRuleFilter={(portfolio) => ({
        assetIds: portfolio.universe.map((asset) => asset.id),
        filters: [],
      })}
      defaultValues={defaultValues}
      assets={data.assets}
      multifactor={data.multifactor}
      rebalancingRules={location.state?.rebalancingRules ?? []}
    />
  );
};

export default PortfolioDefinitionWithAssetUniverseWizard;
